module.exports = __webpack_public_path__ + "202408221624/img/img_renew_pop_ups_bg.a6e0d38a.png";